// extracted by mini-css-extract-plugin
export var grid = "fp-Uk";
export var gridWithRowGap = "fp-Vk";
export var linkTag = "fp-Tk";
export var maxWidthContainer = "fp-Zk";
export var mt0 = "fp-Mk";
export var mt1 = "fp-Nk";
export var mt2 = "fp-Ok";
export var mt3 = "fp-Pk";
export var mt4 = "fp-Qk";
export var mt5 = "fp-Rk";
export var mt6 = "fp-Sk";
export var removeVisuallyHidden = "fp-Xk";
export var visuallyHidden = "fp-Wk";
export var widgetBase = "fp-Yk";